import React, { Component } from 'react';
import { connect } from '~/redux/connect';
import getLoadingState from '~/conclude/loading';

class Loading extends Component {
	render() {
        const { children, loadingState } = this.props;

        let childrenWithProps = React.Children.map(children, child =>
            React.cloneElement(child, loadingState));

		return (
			childrenWithProps
		);
	}
}

const RXLoadingContainer = connect(
    (state) =>  state,
    (dispatch) => ({dispatch}),
    (state, dispatchers, props) => {
    	let { children, className, ...loadingProps } = props;

		return {
			loadingState: getLoadingState(state, loadingProps),
			className,
            children
		}
    }
)(Loading);

export default RXLoadingContainer;